const WPBlockVideo = (blockElem) => {

	const inner = blockElem.querySelector('.wp-block-video-wrapper-inner');
	let video = inner.querySelector('video');

	if(video) {

		const poster = video.getAttribute('poster');
		if(poster) {

			// Create poster
			video.removeAttribute('poster');

			const posterEl = document.createElement('figure');
			posterEl.classList.add('poster');
			const img = new Image();
			img.loading = 'lazy';
			img.src = poster;
			posterEl.appendChild(img);
			inner.appendChild(posterEl);

			// listen for video events
			video.addEventListener('ended', () => blockElem.classList.remove('js-playing'));

			// Enable the poster
			posterEl.addEventListener('click', (e) => {
				e.preventDefault();
				video.play();
				blockElem.classList.add('js-playing');
			});
		}
	}
	else {

		const posterEl = blockElem.querySelector('.poster');
		if(!posterEl) {
			return;
		}

		const controls = blockElem.classList.contains('has-controls');
		const loop = blockElem.classList.contains('is-looping');

		posterEl.addEventListener('click', (e) => {
			e.preventDefault();

			if(!video) {
				const placeholder = blockElem.querySelector('.placeholder');

				video = document.createElement('video');
				video.src = placeholder.getAttribute('data-src');
				video.autoplay = true;
				video.loop = loop;
				if(controls) {
					video.setAttribute('controls', true);
				}
				video.setAttribute('playsinline', true);
				placeholder.appendChild(video);

				if(!loop) {
					video.addEventListener('ended', () => blockElem.classList.remove('js-playing'));
				}
			}
			else {
				video.play();
			}

			blockElem.classList.add('js-playing');
		});
	}

	const figcaption = blockElem.querySelector('figcaption');
	if(figcaption) {
		blockElem.appendChild(figcaption);
	}
};

export default WPBlockVideo;